"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateTime = exports.formatDate = void 0;
var moment_1 = __importDefault(require("moment"));
var HELSINKI_TIME_ZONE = 'Europe/Helsinki';
var helsinkiParts = function (value, options) {
    var parts = new Intl.DateTimeFormat('en-GB', __assign({ timeZone: HELSINKI_TIME_ZONE, hourCycle: 'h23' }, options)).formatToParts(new Date(value));
    return Object.fromEntries(parts.filter(function (part) { return part.type !== 'literal'; }).map(function (part) { return [part.type, part.value]; }));
};
var formatDate = function (string) { return (0, moment_1.default)(string).format('DD.MM.YYYY'); };
exports.formatDate = formatDate;
var formatDateTime = function (string) {
    var parts = helsinkiParts(string, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
    return "".concat(parts.day, ".").concat(parts.month, ".").concat(parts.year, " ").concat(parts.hour, ":").concat(parts.minute);
};
exports.formatDateTime = formatDateTime;
